'use client'

import { Box } from '@web/components/atoms/Layout'
import { useCallback, useEffect, useState } from 'react'

type DynamicBoxProps = {
  speed?: string
}

const DynamicBox = ({ speed = '0.25s', children }: React.PropsWithChildren<DynamicBoxProps>) => {
  const [height, setHeight] = useState(0)
  const [hasMounted, setHasMounted] = useState(false)
  const [isTransitioning, setIsTransitioning] = useState(false)

  const ref = useCallback((node: HTMLElement | null) => {
    if (!node) return
    const resizeObserver = new ResizeObserver(() => {
      setIsTransitioning(true)
      setHeight(node.clientHeight)
    })
    resizeObserver.observe(node)
  }, [])

  useEffect(() => {
    if (height === 0 || hasMounted) {
      return
    }
    setHasMounted(true)
  }, [height])

  return (
    <Box
      display={hasMounted ? 'block' : 'contents'}
      height={height}
      overflow={isTransitioning ? 'hidden' : 'visible'}
      onTransitionEnd={() => setIsTransitioning(false)}
      transition={hasMounted ? `height ${speed} ease-in-out` : ''}
      w="100%"
    >
      <Box ref={ref} w="100%">
        {children}
      </Box>
    </Box>
  )
}

export default DynamicBox
